import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import fontConfig from "../../constants/fonts";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      backgroundColor: "white",
    },
  },
  icon: {
    height: "30vh",
  },
  gridContainer: {
    // backgroundColor: "red",
    height: "100%",
    // padding: "3vh",
  },
  title: {
    ...fontConfig.bold,
    fontSize: "2.5rem",
    color: theme.palette.primary.main,
    // fontFamily: ,
    textTransform: "uppercase",
    letterSpacing: "0.1rem",
    // backgroundColor: theme.palette.primary.main,
    borderRadius: 100,
    // boxShadow: "5px 5px 20px rgba(0,0,0,0.2)",
    // width: "20%",
    // width: "15%",
    textAlign: "center",
    padding: "20px 20px 5px 20px",
  },
}));

const TitleContainer = (props) => {
  const classes = useStyles();

  return (
    <Grid
      container
      direction="column"
      justify="space-evenly"
      alignItems="center"
      className={classes.gridContainer}
    >
      <Grid item>
        <img src={props.icon} alt={props.icon} className={classes.icon} />
      </Grid>
      <Grid item>
        <Typography variant="h4" align="center" className={classes.title}>
          {props.title}
        </Typography>
      </Grid>
    </Grid>
  );
};
export default TitleContainer;
